/**
 * WME cart upsells — package ladder first, then extras not already included.
 * Connor priority: (1) upgrade to NEXT package, (2) only relevant add-ons.
 * Upgrade REPLACES the parent video line (never duplicates).
 *
 * Pure helpers are exported for node:test. Browser boot is a no-op in Node.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }
  root.WmeCartUpsells = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  var MAX_OFFERS = 4;

  var AFRICA_PARENT_ID = 9595144962391;

  /* Africa parent — Red Rebel defaults + White Tigers. Storefront 2026-09-13. */
  var AFRICA_RR = {
    basic: 49147353071959,
    premium: 53756464759127,
    vip: 53756464791895
  };
  var AFRICA_WT = {
    basic: 49147349565783,
    premium: 53756464824663,
    vip: 53756464857431
  };

  /* Standalone crew PDPs (same ladder, different product). */
  var RR_SOLO = {
    basic: 50122077667671,
    premium: 53756458729815,
    vip: 53756458762583
  };
  var WT_SOLO = {
    basic: 50122047586647,
    premium: 53756455387479,
    vip: 53756455420247
  };

  var ADDONS = {
    priority: {
      handle: 'priority-delivery-24hr-turnaround',
      variantId: 53461099839831,
      productId: 10839046521175,
      pence: 899
    },
    second: {
      handle: 'add-a-second-video-premium-upgrade',
      variantId: 53751928062295,
      productId: 10916614046039,
      pence: 2500
    },
    world: {
      handle: 'the-world-tour-4-crews-4-mornings',
      variantId: 54804544258391,
      productId: 11108018782551,
      pence: 11900
    },
    tip: {
      handle: 'tip-the-team',
      variantId: 53750144467287, /* £5 */
      productId: 10916304191831,
      pence: 500,
      anyVariantIds: [53750144434519, 53750144467287, 53750144500055]
    }
  };

  var BUNDLE_HANDLES = {
    '2-personalised-videos-double-the-laughs-bundle': true,
    '3-personalised-videos-party-pack-bundle': true
  };

  var PARENT_HANDLES = {
    'personalized-greeting-video-from-africa': true,
    'personalized-greeting-video-from-africa-red-rebels': true,
    'personalized-greeting-video-from-africa-white-tigers': true,
    'personalized-greeting-video-from-india': true,
    'personalized-greeting-video-from-pakistan': true,
    'personalized-greeting-from-pakistani-village': true,
    'greetings-from-pakistan-with-chicken': true,
    'greetings-from-pakistani-milking-a-goat': true,
    'greetings-from-pakistan-with-sheep': true,
    'personalised-russian-video-greetings': true,
    'anniversary-video-russia-collection': true,
    'diwali-video-mumbai-hype-crew': true,
    'eid-video-pakistani-village-crew': true,
    'fathers-day-video-mumbai-hype-crew': true,
    'fathers-day-video-pakistani-village-crew': true,
    'fathers-day-video-russia-collection': true
  };

  var KNOWN_TIER_BY_VARIANT = {};
  var KNOWN_CREW_BY_VARIANT = {};
  var KNOWN_NEXT_BY_VARIANT = {};

  function registerLadder(map, crew) {
    KNOWN_TIER_BY_VARIANT[map.basic] = 'basic';
    KNOWN_TIER_BY_VARIANT[map.premium] = 'premium';
    KNOWN_TIER_BY_VARIANT[map.vip] = 'vip';
    KNOWN_CREW_BY_VARIANT[map.basic] = crew;
    KNOWN_CREW_BY_VARIANT[map.premium] = crew;
    KNOWN_CREW_BY_VARIANT[map.vip] = crew;
    KNOWN_NEXT_BY_VARIANT[map.basic] = map.premium;
    KNOWN_NEXT_BY_VARIANT[map.premium] = map.vip;
    /* VIP: no next */
  }

  registerLadder(AFRICA_RR, 'red-rebels');
  registerLadder(AFRICA_WT, 'white-tigers');
  registerLadder(RR_SOLO, 'red-rebels');
  registerLadder(WT_SOLO, 'white-tigers');

  var COPY = {
    railTitle: 'Wait — before you pay',
    railSub: 'Most people add one of these. 30 seconds. Then checkout.',
    upgradePremium: {
      eyebrow: 'Most people upgrade',
      title: 'Upgrade to Premium',
      sub: '24-hour delivery + a custom song. Don’t leave them on the 3-day Basic queue.',
      cta: 'Upgrade now'
    },
    upgradeVip: {
      eyebrow: 'The complete gift',
      title: 'Upgrade to VIP',
      sub: 'Priority filming, a personal video gift page, 3 photos, their face on the board and scheduled send. Everything in Premium, with a bigger reveal.',
      cta: 'Make it VIP'
    },
    priority: {
      eyebrow: 'Event this week?',
      title: 'Priority 24-hour delivery',
      sub: 'Basic waits 48–72 hours after we have your details. This puts them in tomorrow’s film queue.',
      cta: 'Get it faster'
    },
    second: {
      eyebrow: 'Most-added extra',
      title: 'Add a second video',
      sub: 'A second crew films another personalised video for the same person. They get two films to watch, not one.',
      cta: 'Add second video'
    },
    world: {
      eyebrow: 'The blowout gift',
      title: 'The World Tour — 4 crews',
      sub: 'Russian, Indian, African and Pakistani videos on one gift page. Choose a different message for each. Replaces your single video.',
      cta: 'Book the World Tour'
    },
    tip: {
      eyebrow: 'The crew see this',
      title: 'Tip the team',
      sub: 'They film in the heat for your person. A fiver goes a long way.',
      cta: 'Add a tip'
    }
  };

  function variantIdOf(item) {
    if (!item) return 0;
    var raw = item.variant_id != null ? item.variant_id : item.id;
    var n = parseInt(raw, 10);
    return isNaN(n) ? 0 : n;
  }

  function productIdOf(item) {
    if (!item) return 0;
    var n = parseInt(item.product_id, 10);
    return isNaN(n) ? 0 : n;
  }

  function handleOf(item) {
    return String((item && item.handle) || '').toLowerCase();
  }

  function blobOf(item) {
    if (!item) return '';
    var parts = [
      item.variant_title,
      item.title,
      item.product_title,
      item.sku,
      item.option1,
      item.option2,
      item.option3
    ];
    if (item.options_with_values && item.options_with_values.length) {
      for (var i = 0; i < item.options_with_values.length; i++) {
        parts.push(item.options_with_values[i].name);
        parts.push(item.options_with_values[i].value);
      }
    }
    return parts.join(' ').toLowerCase();
  }

  /* A catalogue price can arrive in either of two shapes:
       /products/x.json -> pounds as a string, "55.00"
       /products/x.js   -> integer pence, 5500
     Reading the first as the second made every upgrade delta negative, which
     the clamp in findUpgradeTarget then showed as a free-looking "+£0".
     A decimal point only ever comes from the pounds form, so it decides. */
  function catalogPence(value) {
    if (value == null) return 0;
    if (typeof value === 'number') return Math.round(value);
    var s = String(value).trim();
    if (/^\d+$/.test(s)) return parseInt(s, 10);
    var n = parseFloat(s);
    return isNaN(n) ? 0 : Math.round(n * 100);
  }

  function penceOf(item) {
    if (!item) return 0;
    var n = parseInt(item.price, 10);
    if (!isNaN(n) && n > 0 && n < 1000000) return n;
    if (item.final_price != null) {
      n = parseInt(item.final_price, 10);
      if (!isNaN(n)) return n;
    }
    return 0;
  }

  function isRussiaish(item) {
    var h = handleOf(item);
    var b = blobOf(item);
    return h.indexOf('russia') !== -1 || b.indexOf('russia') !== -1;
  }

  function detectTier(item) {
    var vid = variantIdOf(item);
    if (KNOWN_TIER_BY_VARIANT[vid]) return KNOWN_TIER_BY_VARIANT[vid];

    var b = blobOf(item);
    /* Title / option wins over price — Russia Basic is £39.99. */
    if (/\bvip\b/.test(b)) return 'vip';
    if (/\bpremium\b/.test(b)) return 'premium';
    if (/\bbasic\b/.test(b)) return 'basic';

    var p = penceOf(item);
    if (isRussiaish(item)) {
      if (p === 3999) return 'basic';
      if (p === 4999) return 'premium';
      if (p === 5999) return 'vip';
    }
    if (p === 2999) return 'basic';
    if (p === 3499) return 'premium';
    if (p === 3999) return 'premium';
    if (p === 4799) return 'vip';
    if (p === 5499) return 'vip';
    if (p === 4999) return 'vip';
    return null;
  }

  function detectCrew(item) {
    var vid = variantIdOf(item);
    if (KNOWN_CREW_BY_VARIANT[vid]) return KNOWN_CREW_BY_VARIANT[vid];

    var b = blobOf(item);
    if (/white\s*tiger/.test(b)) return 'white-tigers';
    if (/red\s*rebel/.test(b)) return 'red-rebels';
    if (/mumbai|hype crew/.test(b)) return 'mumbai';
    if (/chicken/.test(b)) return 'pk-chicken';
    if (/goat/.test(b)) return 'pk-goat';
    if (/sheep/.test(b)) return 'pk-sheep';
    if (/buffalo/.test(b)) return 'pk-buffalo';
    if (/village/.test(b)) return 'pk-village';
    if (/pakistan/.test(b)) return 'pk';
    if (/russia|rogue|shadow police|pop sparks|black muse/.test(b)) return 'russia';

    /* Africa parent with no crew signal → Red Rebel default (Connor). */
    if (productIdOf(item) === AFRICA_PARENT_ID) return 'red-rebels';
    return 'unknown';
  }

  function isAddonLine(item) {
    var h = handleOf(item);
    if (h === ADDONS.priority.handle) return true;
    if (h === ADDONS.second.handle) return true;
    if (h === ADDONS.world.handle) return true;
    if (h === ADDONS.tip.handle) return true;
    var vid = variantIdOf(item);
    if (vid === ADDONS.priority.variantId) return true;
    if (vid === ADDONS.second.variantId) return true;
    if (vid === ADDONS.world.variantId) return true;
    if (ADDONS.tip.anyVariantIds.indexOf(vid) !== -1) return true;
    var pid = productIdOf(item);
    if (pid === ADDONS.priority.productId) return true;
    if (pid === ADDONS.second.productId) return true;
    if (pid === ADDONS.world.productId) return true;
    if (pid === ADDONS.tip.productId) return true;
    return false;
  }

  function isBundleLine(item) {
    return !!BUNDLE_HANDLES[handleOf(item)];
  }

  function isWorldLine(item) {
    return handleOf(item) === ADDONS.world.handle || variantIdOf(item) === ADDONS.world.variantId;
  }

  function isParentVideoLine(item) {
    if (!item) return false;
    if (isAddonLine(item)) return false;
    if (isBundleLine(item)) return false;
    var h = handleOf(item);
    if (PARENT_HANDLES[h]) return true;
    var type = String(item.product_type || '').toLowerCase();
    if (type === 'video greetings') return true;
    if (h.indexOf('personalized-greeting') === 0) return true;
    if (h.indexOf('personalised-') === 0 && h.indexOf('video') !== -1) return true;
    if (h.indexOf('greetings-from-') === 0) return true;
    if (/-video-/.test(h) && (h.indexOf('mumbai') !== -1 || h.indexOf('pakistan') !== -1 || h.indexOf('russia') !== -1)) {
      return true;
    }
    return false;
  }

  function nextTierName(tier) {
    if (tier === 'basic') return 'premium';
    if (tier === 'premium') return 'vip';
    return null;
  }

  function variantsFromCatalog(item, catalog) {
    if (!catalog) return null;
    if (catalog.variants && catalog.variants.length) return catalog.variants;
    var h = handleOf(item);
    var pid = productIdOf(item);
    var block = catalog[h] || catalog[String(pid)] || catalog[pid];
    if (!block) return null;
    if (block.product && block.product.variants) return block.product.variants;
    if (block.variants) return block.variants;
    return null;
  }

  function variantMatchesCrew(variant, crew, item) {
    if (!variant) return false;
    if (crew === 'unknown' || !crew) return true;
    var text = [variant.title, variant.option1, variant.option2, variant.option3]
      .join(' ')
      .toLowerCase();
    if (crew === 'red-rebels') return /red\s*rebel/.test(text) || (!/white\s*tiger/.test(text) && !/\//.test(String(variant.title || '')));
    if (crew === 'white-tigers') return /white\s*tiger/.test(text);
    if (crew === 'mumbai') return /mumbai|hype/.test(text);
    /* Same-product single-crew PDPs: any variant is the same crew. */
    if (item && handleOf(item).indexOf('white-tigers') !== -1) return true;
    if (item && handleOf(item).indexOf('red-rebels') !== -1) return true;
    /* Multi-option Pakistan parent: require the same option1 token when present. */
    var currentOpt = String((item && (item.option1 || (item.variant_title || '').split(' / ')[0])) || '')
      .toLowerCase()
      .trim();
    if (currentOpt && variant.option1) {
      return String(variant.option1).toLowerCase().trim() === currentOpt;
    }
    return true;
  }

  function variantHasTier(variant, tier) {
    var text = [variant.title, variant.option1, variant.option2, variant.option3]
      .join(' ')
      .toLowerCase();
    if (tier === 'vip') return /\bvip\b/.test(text);
    if (tier === 'premium') return /\bpremium\b/.test(text);
    if (tier === 'basic') return /\bbasic\b/.test(text);
    return false;
  }

  function africaDefaultUpgradeId(item, toTier) {
    var crew = detectCrew(item);
    var map = crew === 'white-tigers' ? AFRICA_WT : AFRICA_RR;
    return map[toTier] || null;
  }

  function findUpgradeTarget(item, catalog) {
    if (!isParentVideoLine(item)) return null;
    var fromTier = detectTier(item);
    var toTier = nextTierName(fromTier);
    if (!toTier) return null;

    var vid = variantIdOf(item);
    var nextId = KNOWN_NEXT_BY_VARIANT[vid] || null;

    if (!nextId) {
      var variants = variantsFromCatalog(item, catalog);
      var crew = detectCrew(item);
      if (variants && variants.length) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          if (!variantHasTier(v, toTier)) continue;
          if (!variantMatchesCrew(v, crew, item)) continue;
          nextId = parseInt(v.id, 10);
          break;
        }
      }
    }

    if (!nextId && productIdOf(item) === AFRICA_PARENT_ID) {
      nextId = africaDefaultUpgradeId(item, toTier);
    }

    if (!nextId || nextId === vid) return null;

    var fromPence = penceOf(item);
    var toPence = fxShop(toTier === 'premium' ? 3999 : toTier === 'vip' ? 5499 : 0);
    if (fromTier === 'basic' && isRussiaish(item)) toPence = fxShop(4999);
    var pricedVariants = variantsFromCatalog(item, catalog) || [];
    var pricedTarget = pricedVariants.find(function (v) { return parseInt(v.id, 10) === nextId; });
    if (pricedTarget) {
      if (pricedTarget.available === false) return null;
      toPence = catalogPence(pricedTarget.price);
    }
    var delta = toPence && fromPence ? toPence - fromPence : 1000;
    /* An upgrade that costs nothing is bad data, not a bargain. Saying so
       out loud on the card is worse than leaving the card out. */
    if (delta <= 0) return null;

    return {
      item: item,
      fromTier: fromTier,
      toTier: toTier,
      variantId: nextId,
      crew: detectCrew(item),
      deltaPence: Math.max(0, delta) * (item.quantity || 1)
    };
  }

  function cartItems(cart) {
    if (!cart) return [];
    return cart.items || cart.line_items || [];
  }

  function cartHasHandle(cart, handle) {
    var items = cartItems(cart);
    var h = String(handle || '').toLowerCase();
    for (var i = 0; i < items.length; i++) {
      if (handleOf(items[i]) === h) return true;
    }
    return false;
  }

  function cartHasVariant(cart, ids) {
    var list = Array.isArray(ids) ? ids : [ids];
    var want = {};
    for (var i = 0; i < list.length; i++) want[parseInt(list[i], 10)] = true;
    var items = cartItems(cart);
    for (var j = 0; j < items.length; j++) {
      if (want[variantIdOf(items[j])]) return true;
    }
    return false;
  }

  function parentLines(cart) {
    var items = cartItems(cart);
    var out = [];
    for (var i = 0; i < items.length; i++) {
      if (isParentVideoLine(items[i])) out.push(items[i]);
    }
    return out;
  }

  function isSingleCrewOrder(cart) {
    if (cartHasHandle(cart, ADDONS.world.handle)) return false;
    var items = cartItems(cart);
    for (var i = 0; i < items.length; i++) {
      if (isBundleLine(items[i])) return false;
    }
    var parents = parentLines(cart);
    if (parents.length !== 1 || items.length !== 1 || parents[0].quantity !== 1) return false;
    return true;
  }

  function secondAlreadyIncluded(cart) {
    if (cartHasHandle(cart, ADDONS.second.handle)) return true;
    if (cartHasVariant(cart, ADDONS.second.variantId)) return true;
    if (cartHasHandle(cart, ADDONS.world.handle)) return true;
    var items = cartItems(cart);
    for (var i = 0; i < items.length; i++) {
      if (isBundleLine(items[i])) return true;
    }
    /* Two or more parent videos already = they have a second video. */
    if (parentLines(cart).length >= 2) return true;
    return false;
  }

  function priorityAlreadyIncluded(cart, tier) {
    if (tier === 'premium' || tier === 'vip') return true;
    if (cartHasHandle(cart, ADDONS.priority.handle)) return true;
    if (cartHasVariant(cart, ADDONS.priority.variantId)) return true;
    return false;
  }

  function tipAlreadyInCart(cart) {
    if (cartHasHandle(cart, ADDONS.tip.handle)) return true;
    return cartHasVariant(cart, ADDONS.tip.anyVariantIds);
  }

  function highestParentTier(cart) {
    var parents = parentLines(cart);
    var rank = { basic: 1, premium: 2, vip: 3 };
    var best = null;
    var bestN = 0;
    for (var i = 0; i < parents.length; i++) {
      var t = detectTier(parents[i]);
      var n = rank[t] || 0;
      if (n > bestN) {
        bestN = n;
        best = t;
      }
    }
    return best;
  }

  function pickUpgradeLine(cart, catalog) {
    var parents = parentLines(cart);
    var rank = { basic: 1, premium: 2, vip: 3 };
    var best = null;
    var bestRank = 99;
    for (var i = 0; i < parents.length; i++) {
      var target = findUpgradeTarget(parents[i], catalog);
      if (!target) continue;
      var r = rank[target.fromTier] || 9;
      if (r < bestRank) {
        bestRank = r;
        best = target;
      }
    }
    return best;
  }

  /* --------------------------------------------------------------------------
     Money across markets.

     This rail used to switch itself off for any non-GBP cart, so every
     overseas customer saw no upsells at all. Three price sources meet here:

       /cart.js         -> the customer's market currency
       /products/x.json -> the customer's market currency, as pounds strings
       the literals below (3999, ADDONS[].pence) -> the shop's own currency

     Only the last needs converting, and only as a fallback: a market sets its
     own rounded prices (£25 lands at $35, not $34.45), so read the real one
     wherever the catalogue has it.

       fxShop() : shop pence -> market pence. Never a cart or catalogue price.
       money()  : market pence -> a string in the active currency.
     ---------------------------------------------------------------------- */
  function currencyInfo() {
    return (typeof window !== 'undefined' && window.Shopify && window.Shopify.currency) || null;
  }

  function activeCurrency() {
    var c = currencyInfo();
    return (c && c.active) || 'GBP';
  }

  function shopRate() {
    var c = currencyInfo();
    var r = c ? parseFloat(c.rate) : NaN;
    /* A missing or absurd rate converts nothing rather than inventing a price. */
    return r > 0.001 && r < 10000 ? r : 1;
  }

  function fxShop(pence) {
    return Math.round((pence || 0) * shopRate());
  }

  function money(pence) {
    var n = (pence || 0) / 100;
    var cur = activeCurrency();
    var whole = Math.round(n * 100) % 100 === 0;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: cur,
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: whole ? 0 : 2
      }).format(n);
    } catch (e) {
      /* Unknown code or no Intl — a bare number is worse than a prefixed one. */
      return (cur === 'GBP' ? '£' : cur + ' ') + (whole ? String(Math.round(n)) : n.toFixed(2));
    }
  }

  /* An add-on's real price in this market, or the sterling literal converted
     when the catalogue has not been loaded for it. */
  function addonPence(addon, catalog) {
    var block = catalog && catalog[addon.handle];
    var variants = block && ((block.product && block.product.variants) || block.variants);
    if (variants) {
      for (var i = 0; i < variants.length; i++) {
        if (parseInt(variants[i].id, 10) !== addon.variantId) continue;
        var p = catalogPence(variants[i].price);
        if (p > 0) return p;
      }
    }
    return fxShop(addon.pence);
  }

  function buildOffers(cart, catalog) {
    var items = cartItems(cart);
    if (!items.length) return [];
    var parents = parentLines(cart);
    var hasVideoContext = parents.length > 0;
    if (!hasVideoContext) {
      for (var hi = 0; hi < items.length; hi++) {
        if (isBundleLine(items[hi]) || isWorldLine(items[hi])) {
          hasVideoContext = true;
          break;
        }
      }
    }
    if (!hasVideoContext) return [];

    var offers = [];
    var upgrade = pickUpgradeLine(cart, catalog);
    var tier = highestParentTier(cart);

    /* VIP already has the top package — never offer Upgrade-to-VIP again. */
    if (upgrade && upgrade.toTier === 'vip' && tier === 'vip') upgrade = null;
    if (tier === 'vip') upgrade = null;

    if (upgrade) {
      var copy = upgrade.toTier === 'vip' ? COPY.upgradeVip : COPY.upgradePremium;
      offers.push({
        id: 'upgrade',
        kind: 'replace',
        variantId: upgrade.variantId,
        replaceKey: upgrade.item.key,
        replaceVariantId: variantIdOf(upgrade.item),
        fromTier: upgrade.fromTier,
        toTier: upgrade.toTier,
        crew: upgrade.crew,
        priceLabel: '+' + money(upgrade.deltaPence),
        eyebrow: copy.eyebrow,
        title: copy.title,
        sub: copy.sub,
        cta: copy.cta,
        highlight: true
      });
    }

    /* 2nd video ALWAYS when not already in the cart — reserved ahead of World Tour / tip. */
    if (!secondAlreadyIncluded(cart)) {
      offers.push({
        id: 'second',
        kind: 'add',
        variantId: ADDONS.second.variantId,
        priceLabel: money(addonPence(ADDONS.second, catalog)),
        eyebrow: COPY.second.eyebrow,
        title: COPY.second.title,
        sub: COPY.second.sub,
        cta: COPY.second.cta
      });
    }

    if (isSingleCrewOrder(cart) && !cartHasHandle(cart, ADDONS.world.handle)) {
      offers.push({
        id: 'world',
        kind: 'replace',
        replaceKey: parents[0].key,
        replaceVariantId: variantIdOf(parents[0]),
        variantId: ADDONS.world.variantId,
        priceLabel: money(addonPence(ADDONS.world, catalog)) + ' total',
        eyebrow: COPY.world.eyebrow,
        title: COPY.world.title,
        sub: COPY.world.sub,
        cta: COPY.world.cta
      });
    }

    if (!tipAlreadyInCart(cart) && (parents.length || items.some(isWorldLine) || items.some(isBundleLine))) {
      offers.push({
        id: 'tip',
        kind: 'add',
        variantId: ADDONS.tip.variantId,
        priceLabel: money(addonPence(ADDONS.tip, catalog)),
        eyebrow: COPY.tip.eyebrow,
        title: COPY.tip.title,
        sub: COPY.tip.sub,
        cta: COPY.tip.cta
      });
    }

    /* Skip-queue / Priority is already inside Premium + VIP. Never duplicate it
       beside an upgrade-to-Premium (that upgrade *is* the 24-hour path). */
    if (parents.length && !upgrade && !priorityAlreadyIncluded(cart, tier) && offers.length < MAX_OFFERS) {
      offers.push({
        id: 'priority',
        kind: 'add',
        variantId: ADDONS.priority.variantId,
        priceLabel: money(addonPence(ADDONS.priority, catalog)),
        eyebrow: COPY.priority.eyebrow,
        title: COPY.priority.title,
        sub: COPY.priority.sub,
        cta: COPY.priority.cta
      });
    }

    return offers.slice(0, MAX_OFFERS);
  }

  /* ------------------------------------------------------------------ */
  /* Browser boot                                                        */
  /* ------------------------------------------------------------------ */

  var catalogCache = {};
  var busy = false;
  var lastCartJson = null;
  var lastPaintKey = '';
  var offersById = {};
  var delegatedCtas = false;
  var booted = false;

  function fetchJson(url, body, method) {
    var opts = {
      method: method || (body ? 'POST' : 'GET'),
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    };
    if (body) {
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return fetch(url, opts).then(function (res) {
      if (!res.ok) {
        return res.text().then(function (t) {
          var err = new Error('HTTP ' + res.status);
          err.body = t;
          throw err;
        });
      }
      return res.json();
    });
  }

  function loadProductCatalog(handle) {
    if (!handle) return Promise.resolve(null);
    if (catalogCache[handle]) return Promise.resolve(catalogCache[handle]);
    return fetchJson('/products/' + encodeURIComponent(handle) + '.json')
      .then(function (data) {
        catalogCache[handle] = data;
        return data;
      })
      .catch(function () {
        return null;
      });
  }

  function enrichCatalogForCart(cart) {
    var parents = parentLines(cart);
    var missing = [];
    for (var i = 0; i < parents.length; i++) {
      var item = parents[i];
      if (!nextTierName(detectTier(item))) continue;
      var h = handleOf(item);
      if (h && !catalogCache[h]) missing.push(h);
    }
    /* The add-on cards quote a price, so their products are worth loading
       alongside the parents — the alternative is quoting a converted
       sterling guess that the market's own rounding disagrees with. */
    if (parents.length) {
      ['second', 'world', 'tip', 'priority'].forEach(function (k) {
        var h = ADDONS[k] && ADDONS[k].handle;
        if (h && !catalogCache[h] && missing.indexOf(h) === -1) missing.push(h);
      });
    }
    if (!missing.length) {
      var merged = {};
      Object.keys(catalogCache).forEach(function (k) {
        merged[k] = catalogCache[k];
      });
      return Promise.resolve(merged);
    }
    return Promise.all(missing.map(loadProductCatalog)).then(function () {
      var merged = {};
      Object.keys(catalogCache).forEach(function (k) {
        merged[k] = catalogCache[k];
      });
      return merged;
    });
  }

  function lineProperties(item) {
    var props = {};
    if (!item || !item.properties) return props;
    Object.keys(item.properties).forEach(function (k) {
      var val = item.properties[k];
      if (val == null || val === '') return;
      props[k] = val;
    });
    return props;
  }

  function replaceParentLine(item, newVariantId) {
    var key = item.key;
    var qty = item.quantity || 1;
    var props = lineProperties(item);
    var restore = {
      id: variantIdOf(item),
      quantity: qty
    };
    if (Object.keys(props).length) restore.properties = props;

    return fetchJson('/cart/change.js', { id: key, quantity: 0 }).then(function () {
      var addBody = { id: newVariantId, quantity: qty };
      if (Object.keys(props).length) addBody.properties = props;
      if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
        addBody.selling_plan = item.selling_plan_allocation.selling_plan.id;
      }
      return fetchJson('/cart/add.js', addBody).catch(function (err) {
        return fetchJson('/cart/add.js', restore).then(function () {
          throw err;
        });
      });
    });
  }

  function addVariant(variantId) {
    return fetchJson('/cart/add.js', { id: variantId, quantity: 1 });
  }

  function notifyCart(cart) {
    try {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
    } catch (e) {}
    /* Dawn / Refresh section reload when on /cart */
    try {
      if (window.location && /\/cart\/?$/.test(window.location.pathname)) {
        var root = document.querySelector('#main-cart-items, cart-items, #CartPage');
        var sectionId = root && root.getAttribute('data-id');
        if (sectionId && window.fetch) {
          fetchJson('/?sections=' + encodeURIComponent(sectionId)).then(function (sections) {
            var html = sections && sections[sectionId];
            if (!html || !root) return;
            var wrap = document.createElement('div');
            wrap.innerHTML = html;
            var next = wrap.querySelector('#main-cart-items, cart-items');
            if (next) root.innerHTML = next.innerHTML;
          }).catch(function () {});
        }
      }
    } catch (e2) {}
  }

  function hideEssentialGeneric(on) {
    try {
      document.documentElement.classList.toggle('wme-cart-upsells-active', !!on);
    } catch (e) {}
  }

  function isProtectedHost(el) {
    if (!el || !el.closest) return false;
    /* ReConvert aftersell + Globo option widgets are apps — never hijack them. */
    return !!el.closest(
      [
        '[id*="reconvert"]',
        '[class*="reconvert"]',
        '[data-reconvert]',
        '#rc-widget',
        '.reconvert-widget',
        '#globo-product-options',
        '.globo-product-options',
        '.gpo-container'
      ].join(',')
    );
  }

  function mountPoints() {
    var points = [];
    var seen = {};
    function add(el, where) {
      if (!el || isProtectedHost(el)) return;
      var key = where + (el.id || el.className || '');
      if (seen[key]) return;
      seen[key] = true;
      points.push({ el: el, where: where });
    }

    /* Cart page: one rail, in the dedicated upsell section. Do not also clone
       it above the checkout footer — that doubled theme JS work on /cart. */
    var named = document.querySelector('[id$="__wme-upsell"]');
    if (named) {
      add(named, 'empty');
    } else if (/\/cart\/?$/.test((window.location && window.location.pathname) || '')) {
      add(document.getElementById('main-cart-footer'), 'before');
      add(document.querySelector('.cart__footer'), 'before');
    }

    var drawers = document.querySelectorAll(
      [
        'essential-cart-drawer',
        '#ess-cart-drawer',
        '[class*="ess-Cart"]',
        '[class*="essential-cart"]',
        'cart-drawer',
        '#CartDrawer',
        '.cart-drawer',
        '[data-cart-drawer]'
      ].join(',')
    );
    for (var i = 0; i < drawers.length; i++) {
      var d = drawers[i];
      if (isProtectedHost(d)) continue;
      var footer =
        d.querySelector('[class*="checkout"], [class*="Checkout"], .cart__ctas, [name="checkout"]');
      if (footer && !isProtectedHost(footer)) add(footer, 'before');
      else add(d, 'append');
    }
    return points;
  }

  function ensureRailEl(host, where, slot) {
    var id = 'wme-cart-upsells-' + slot;
    var existing = document.getElementById(id);
    if (existing && existing.parentNode === (where === 'empty' ? host : host.parentNode || host)) {
      return existing;
    }
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
    var el = document.createElement('div');
    el.id = id;
    el.className = 'wme-cart-upsells';
    el.setAttribute('data-wme-cart-upsells', slot);
    if (where === 'empty') {
      host.innerHTML = '';
      host.appendChild(el);
    } else if (where === 'before' && host.parentNode) {
      host.parentNode.insertBefore(el, host);
    } else if (where === 'after' && host.parentNode) {
      if (host.nextSibling) host.parentNode.insertBefore(el, host.nextSibling);
      else host.parentNode.appendChild(el);
    } else {
      host.appendChild(el);
    }
    return el;
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderRail(el, offers) {
    if (!el) return;
    if (!offers || !offers.length) {
      el.hidden = true;
      el.innerHTML = '';
      return;
    }
    el.hidden = false;
    var cards = offers
      .map(function (o) {
        return (
          '<article class="wme-cu-card' +
          (o.highlight ? ' wme-cu-card--upgrade' : '') +
          '" data-offer="' +
          escapeHtml(o.id) +
          '">' +
          '<div class="wme-cu-card__text">' +
          '<p class="wme-cu-card__eyebrow">' +
          escapeHtml(o.eyebrow) +
          '</p>' +
          '<h3 class="wme-cu-card__title">' +
          escapeHtml(o.title) +
          '</h3>' +
          '<p class="wme-cu-card__sub" id="wme-cu-desc-' +
          escapeHtml(o.id) +
          '">' +
          escapeHtml(o.sub) +
          '</p>' +
          '</div>' +
          '<div class="wme-cu-card__action">' +
          '<span class="wme-cu-card__price">' +
          escapeHtml(o.priceLabel) +
          '</span>' +
          '<button type="button" class="wme-cu-card__btn" data-wme-cu-cta data-offer="' +
          escapeHtml(o.id) +
          '" aria-describedby="wme-cu-desc-' +
          escapeHtml(o.id) +
          '">' +
          escapeHtml(o.cta) +
          '</button>' +
          '</div>' +
          '</article>'
        );
      })
      .join('');
    el.innerHTML =
      '<div class="wme-cu">' +
      '<div class="wme-cu__head">' +
      '<p class="wme-cu__kicker">Don’t check out yet</p>' +
      '<h2 class="wme-cu__title">' +
      escapeHtml(COPY.railTitle) +
      '</h2>' +
      '<p class="wme-cu__sub">' +
      escapeHtml(COPY.railSub) +
      '</p>' +
      '</div>' +
      '<div class="wme-cu__list">' +
      cards +
      '</div>' +
      '<p class="wme-cu__status" data-wme-cu-status role="status" aria-live="polite"></p>' +
      '</div>';
  }

  function setStatus(msg, isError) {
    var nodes = document.querySelectorAll('[data-wme-cu-status]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = msg || '';
      nodes[i].classList.toggle('is-error', !!isError);
    }
  }

  function bindCtas(offers) {
    offersById = {};
    for (var i = 0; i < (offers || []).length; i++) offersById[offers[i].id] = offers[i];
    if (delegatedCtas || typeof document === 'undefined') return;
    delegatedCtas = true;
    document.addEventListener('click', function (ev) {
      var btn = ev.target && ev.target.closest && ev.target.closest('[data-wme-cu-cta]');
      if (!btn) return;
      ev.preventDefault();
      if (busy) return;
      var offer = offersById[btn.getAttribute('data-offer')];
      if (!offer) return;
      runOffer(offer, btn);
    });
  }

  function findReplacementLine(cart, offer) {
    var items = cartItems(cart);
    var matches = items.filter(function (item) {
      if (offer.replaceKey) return item.key === offer.replaceKey;
      return variantIdOf(item) === offer.replaceVariantId;
    });
    return matches.length === 1 ? matches[0] : null;
  }

  function runOffer(offer, btn) {
    busy = true;
    if (btn) {
      btn.disabled = true;
      btn.classList.add('is-busy');
    }
    setStatus(offer.kind === 'replace' ? 'Swapping your package…' : 'Adding…');

    var work;
    if (offer.kind === 'replace') {
      var item = findReplacementLine(lastCartJson, offer);
      if (!item) {
        busy = false;
        setStatus('Couldn’t find that video line — refresh and try again.', true);
        if (btn) {
          btn.disabled = false;
          btn.classList.remove('is-busy');
        }
        return;
      }
      work = replaceParentLine(item, offer.variantId);
    } else {
      work = addVariant(offer.variantId);
    }

    work
      .then(function () {
        return fetchJson('/cart.js');
      })
      .then(function (cart) {
        lastCartJson = cart;
        notifyCart(cart);
        /* Dawn's full cart is server-rendered; refresh its lines and total too. */
        if (/\/cart\/?$/.test(window.location.pathname)) {
          window.location.reload();
          return;
        }
        setStatus(offer.kind === 'replace' ? 'Package upgraded. Checkout when you’re ready.' : 'Added. Anything else?');
        return paint(cart);
      })
      .catch(function () {
        setStatus('That didn’t go through — try once more.', true);
      })
      .then(function () {
        busy = false;
        if (btn) {
          btn.disabled = false;
          btn.classList.remove('is-busy');
        }
      });
  }

  function paint(cart) {
    return enrichCatalogForCart(cart).then(function (catalog) {
      var offers = buildOffers(cart, catalog);
      bindCtas(offers);
      hideEssentialGeneric(offers.length > 0);
      var paintKey =
        (cart && (cart.item_count + ':' + cart.total_price)) +
        '|' +
        offers
          .map(function (o) {
            return o.id + ':' + o.variantId + ':' + (o.replaceKey || '');
          })
          .join(',');
      var existingRail = document.querySelector('[data-wme-cart-upsells]');
      if (paintKey === lastPaintKey && existingRail) return offers;
      lastPaintKey = paintKey;

      var points = mountPoints();
      if (!points.length && offers.length) {
        var fallback = document.getElementById('wme-cart-upsells-root');
        if (fallback) points = [{ el: fallback, where: 'empty' }];
      }
      var used = {};
      for (var i = 0; i < points.length; i++) {
        var slot = points[i].where + '-' + i;
        if (used[points[i].el]) continue;
        used[points[i].el] = true;
        var rail = ensureRailEl(points[i].el, points[i].where, slot);
        renderRail(rail, offers);
      }
      return offers;
    });
  }

  function refresh() {
    return fetchJson('/cart.js')
      .then(function (cart) {
        lastCartJson = cart;
        return paint(cart);
      })
      .catch(function () {});
  }

  function patchFetch() {
    if (typeof window === 'undefined' || !window.fetch || window.fetch._wmeCu) return;
    var orig = window.fetch;
    window.fetch = function () {
      var input = arguments[0];
      var url = '';
      try {
        url = typeof input === 'string' ? input : (input && input.url) || '';
      } catch (e) {}
      return orig.apply(this, arguments).then(function (res) {
        if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url))) {
          setTimeout(refresh, 80);
        }
        return res;
      });
    };
    window.fetch._wmeCu = true;
  }

  function boot() {
    if (booted || typeof document === 'undefined') return;
    booted = true;
    patchFetch();
    document.addEventListener('cart:updated', function (ev) {
      if (ev && ev.detail && ev.detail.cart) {
        lastCartJson = ev.detail.cart;
        lastPaintKey = '';
        paint(ev.detail.cart);
      } else {
        refresh();
      }
    });
    document.addEventListener('cart:change', refresh);
    document.addEventListener('cart:refresh', function () {
      setTimeout(refresh, 40);
    });
    if (document.body) {
      var hostTimer = null;
      var obs = new MutationObserver(function (muts) {
        if (!lastCartJson) return;
        var relevant = false;
        for (var i = 0; i < muts.length && !relevant; i++) {
          var t = muts[i].target;
          if (t && t.closest && t.closest('essential-cart-drawer, cart-drawer, #CartDrawer, [data-cart-drawer]')) {
            relevant = true;
            break;
          }
          var nodes = muts[i].addedNodes;
          for (var j = 0; j < nodes.length; j++) {
            var el = nodes[j];
            if (!el || el.nodeType !== 1) continue;
            if (
              (el.matches &&
                el.matches('essential-cart-drawer, cart-drawer, #CartDrawer, [data-cart-drawer]')) ||
              (el.querySelector &&
                el.querySelector('essential-cart-drawer, cart-drawer, #CartDrawer, [data-cart-drawer]'))
            ) {
              relevant = true;
              break;
            }
          }
        }
        if (!relevant) return;
        if (hostTimer) return;
        hostTimer = setTimeout(function () {
          hostTimer = null;
          var drawer = document.querySelector(
            'essential-cart-drawer, cart-drawer, #CartDrawer, [data-cart-drawer]'
          );
          if (!drawer) return;
          if (drawer.querySelector('[data-wme-cart-upsells]')) return;
          lastPaintKey = '';
          paint(lastCartJson);
        }, 250);
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }
    refresh();
  }

  function bootWhenNeeded() {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    if (/\/cart\/?$/.test(window.location.pathname || '')) {
      boot();
      return;
    }
    function intent(ev) {
      if (booted) return;
      var t = ev && ev.target;
      if (!t || !t.closest) {
        boot();
        return;
      }
      if (
        t.closest(
          'a[href*="/cart"], [href="/cart"], .header__icon--cart, #cart-icon-bubble, essential-cart-drawer, cart-drawer, [data-cart-drawer], [aria-controls*="cart" i]'
        )
      ) {
        boot();
      }
    }
    document.addEventListener('click', intent, true);
    document.addEventListener('pointerdown', intent, true);
    document.addEventListener('cart:updated', boot);
    document.addEventListener('cart:change', boot);
    document.addEventListener('cart:refresh', boot);
  }

  if (typeof document !== 'undefined' && typeof window !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootWhenNeeded);
    } else {
      bootWhenNeeded();
    }
  }

  return {
    MAX_OFFERS: MAX_OFFERS,
    AFRICA_PARENT_ID: AFRICA_PARENT_ID,
    AFRICA_RR: AFRICA_RR,
    AFRICA_WT: AFRICA_WT,
    RR_SOLO: RR_SOLO,
    WT_SOLO: WT_SOLO,
    ADDONS: ADDONS,
    COPY: COPY,
    variantIdOf: variantIdOf,
    detectTier: detectTier,
    detectCrew: detectCrew,
    isParentVideoLine: isParentVideoLine,
    isAddonLine: isAddonLine,
    isSingleCrewOrder: isSingleCrewOrder,
    findUpgradeTarget: findUpgradeTarget,
    findReplacementLine: findReplacementLine,
    cartHasHandle: cartHasHandle,
    cartHasVariant: cartHasVariant,
    secondAlreadyIncluded: secondAlreadyIncluded,
    priorityAlreadyIncluded: priorityAlreadyIncluded,
    buildOffers: buildOffers,
    nextTierName: nextTierName
  };
});